import cs from 'classnames';

// TODO: do this without having to extend string prototype
// Update: This is the best way I if we want to use primitives

// eslint-disable-next-line no-extend-native
Object.defineProperty(String.prototype, 'withModifier', {
  value(modifier = {}) {
    if (typeof modifier === 'string') return [this, modifier].join('-');

    return cs(
      Object.keys(modifier).reduce(
        (modifiers, key) =>
          Object.assign(modifiers, {
            [`${this}-${key}`]: modifier[key],
          }),
        {
          [this]: true,
        }
      )
    );
  },
  configurable: true,
  enumerable: false,
  writeable: true,
});

const bemGenerator = (block, elements = []) =>
  Object.assign(
    elements.reduce(
      (obj, curr) =>
        Object.assign(obj, {
          [curr]: [block, curr].join('--'),
        }),
      {}
    ),
    {
      block,
    }
  );

export default bemGenerator;
